import React, { useRef, useEffect, useState } from 'react';
import '../../../App.css';
import { AttachFileOutlined, GitHub, InsertLinkOutlined, LanguageOutlined, NavigateNext, YouTube } from '@mui/icons-material';




// -------------------- CSS ------------------------
export const style = `
    .product-url-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: auto;
        position: fit-content;
        border-radius: 100px;
        transition: background-color 0.15s;
        text-decoration: none;
    }

    .product-url-content {
        position: relative;
        text-align: center;
        width: 100%;
        align-self: flex-start;
        display: flex;
        align-items: center;
        color: var(--common-main-color);
        font-weight: bold;
    }
`;
// -------------------------------------------------



const ComponentProductUrl = ({
    url,
    customAlign='flex-end',
    isParentHovered=true
}) => {
    React.useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.innerText = style;
        document.head.appendChild(styleSheet);
        return () => styleSheet.remove();
    }, []);


    const [isHovered, setIsHovered] = useState(false);
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };



    return (
        <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: customAlign,
            margin: (customAlign === 'center') ? '7px 0' : '0'
        }}>
            <a
                href={url}
                style={{
                    padding: (customAlign === 'center') ? '6px 15px' : '8px 20px',
                    width: 'fit-content'
                }}
                className="product-url-container"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <div className="product-url-content">
                    <span
                        style={{
                            display: 'inline-flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            textAlign: 'center',
                            width: '100%',
                            color: (isHovered)
                                ? "#20d761"
                                : (isParentHovered)
                                    ? 'var(--common-main-green-deep-color)'
                                    : 'var(--common-main-color)',
                            userSelect: 'auto',
                            display: 'inline-flex',
                            alignItems: 'center',
                            fontSize: '13px'
                        }}
                    >
                        もっと詳しく見る
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            backgroundColor: (isParentHovered) ? 'var(--common-back-green-deep2-color)' : 'var(--common-back-deep2-color)',
                            marginLeft: '5px'
                        }}>
                            <NavigateNext style={{
                                color: (isHovered)
                                    ? "#20d761"
                                    : (isParentHovered) ? 'var(--common-main-green-deep-color)' : 'var(--common-main-deep-color)',
                                fontSize: '18px'
                            }} />
                        </div>
                    </span>
                </div>
            </a>
        </div>
    );
};

export default ComponentProductUrl;